export default {
  GET_ALL: `#graphql
  query getConveyors($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getConveyors(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        conveyor,
        activeBrands,
        activeConveyor,
        order,
        cost,
        image,
        folder
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getConveyorsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getConveyorsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        conveyor,
        activeBrands,
        activeConveyor,
        order,
        cost,
        image,
        folder,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewConveyor($conveyor: ConveyorInput!) {
    newConveyor(input: $conveyor)
    {
      conveyor,
      activeBrands,
      activeConveyor,
      order,
      cost,
      image,
      folder
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateConveyor($conveyor: String!, $conveyorUpdate: ConveyorUpdateInput!) {
    updateConveyor(conveyor:$conveyor, conveyorUpdate: $conveyorUpdate)
    {
      conveyor
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteConveyor($conveyor: String!) {
    deleteConveyor(conveyor:$conveyor)
    {
      conveyor
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/conveyor.js